import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Only scroll to top for product detail pages
    if (pathname.startsWith('/product/')) {
      window.scrollTo(0, 0);
    }
    // For all other pages, let the browser handle scroll restoration naturally
    // This includes preserving scroll position when navigating back to /search
  }, [pathname]);

  return null;
};

export default ScrollToTop;
